import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';
import { push } from 'connected-react-router';

import { UPLOAD_CSV_CUSTOM_WATCHLIST } from '../types/uploadCsvCustomWatchlistTypes';
import { uploadCsvCustomWatchlistFulfilled, uploadCsvCustomWatchlistPending, uploadCsvCustomWatchlistRejected } from '../actions';
import { sendApiRequest } from '../../../actions/apiRequestActions';
import { notifyError, notifySuccess, notifyWarning } from '../../../actions';
import { CUSTOM_WATCHLIST_MESSAGES } from '../constants/customWatchlistMessages';
import generateError from '../../../utilities/generateError';
import routesConfig from '../../../routes/routes-config';

const uploadPayload = payload => ({
  method: 'post',
  url: 'watchlist/importcustomwatchlistentriescsv',
  onSuccess: [
    uploadCsvCustomWatchlistFulfilled,
    (success) => success.data === true ? notifySuccess(CUSTOM_WATCHLIST_MESSAGES.CREATED) : notifyWarning(success.data),
    () => push(routesConfig.uploadCustomWatchlistPage.path),
  ],
  onError: [
    uploadCsvCustomWatchlistRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'formDataApi',
};

const uploadCustomWatchlistEpic$ = action$ => action$.pipe(
  ofType(UPLOAD_CSV_CUSTOM_WATCHLIST.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(uploadCsvCustomWatchlistPending()),
    of(sendApiRequest(uploadPayload(payload), meta)),
  )),
);

export default uploadCustomWatchlistEpic$;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/uploadCustomWatchlistEpic.js